<invoice-cash-desk-edit [medicalappointmentid]="medicalappointmentid" (onClose)="close()"></invoice-cash-desk-edit>
